// Auto-generated by splitter.py — do not regenerate; edit directly.

import React from 'react';
import { DESIGN_TEMPLATES } from '../../data/comms';
import { EmailPreviewCard } from './EmailPreviewCard';

export const DesignPreviewCard = ({ template, fields, eventLabel, venueLabel, dateLabel, category, organizerLabel, size = 'md', kind = 'ticket', text }) => {
  if (kind === 'email') return <EmailPreviewCard template={template} blocks={fields} text={text} eventLabel={eventLabel} venueLabel={venueLabel} dateLabel={dateLabel} size={size} />;
  const t = template || DESIGN_TEMPLATES[0];
  const w = size === 'sm' ? 'max-w-[280px]' : 'max-w-[400px]';
  return (
    <div className={`bg-white border border-[#E6E4E1] rounded-md overflow-hidden ${w} mx-auto`}>
      <div className="px-4 py-2.5" style={{ backgroundColor: t.headerColor, color: 'white' }}>
        <div className="text-[9px] uppercase tracking-[0.08em] opacity-70">{t.style === 'wristband' ? 'Wristband' : t.style === 'badge' ? 'Badge' : t.style === 'wallet' ? 'Wallet pass' : 'Ticket'}</div>
        <div className="text-[12px] font-semibold tabular-nums">{category || 'General'}</div>
      </div>
      <div className="p-4">
        {fields.organizer && <div className="text-[10px] text-[#6B7280] mb-1">{organizerLabel || 'Organizer'}</div>}
        {fields.eventName && <div className="text-[13px] font-semibold text-[#1F2937] mb-0.5 leading-tight">{eventLabel || 'Event name'}</div>}
        {fields.dateTime && <div className="text-[10.5px] text-[#4B5563]">{dateLabel || '24 May 2026, 19:00 EAT'}</div>}
        {fields.venue && <div className="text-[10.5px] text-[#4B5563] mb-2">{venueLabel || 'Venue'}</div>}
        <div className="border-t border-dashed border-[#E6E4E1] my-2"></div>
        <div className="flex items-start gap-3">
          <div className="flex-1 text-[10.5px] grid grid-cols-2 gap-x-2 gap-y-0.5">
            {fields.gate    && <div><span className="text-[#9CA3AF]">Gate</span> · <span className="font-medium">A</span></div>}
            {fields.section && <div><span className="text-[#9CA3AF]">Section</span> · <span className="font-medium">12</span></div>}
            {fields.row     && <div><span className="text-[#9CA3AF]">Row</span> · <span className="font-medium">F</span></div>}
            {fields.seat    && <div><span className="text-[#9CA3AF]">Seat</span> · <span className="font-medium">23</span></div>}
            {fields.buyerName && <div className="col-span-2 mt-1"><span className="text-[#9CA3AF]">Buyer</span> · <span className="font-medium">Mariam K.</span></div>}
          </div>
          {fields.qr && <div className="w-14 h-14 border-2 flex items-center justify-center text-[8px]" style={{ borderColor: t.accentColor, color: t.accentColor }}>QR</div>}
        </div>
        {fields.sponsor && <div className="border-t border-dashed border-[#E6E4E1] mt-3 pt-2 text-[9.5px] text-center" style={{ color: t.accentColor }}>sponsored by · partner area</div>}
        {fields.terms && <div className="mt-2 text-[8px] text-[#9CA3AF] leading-tight">By holding this ticket you accept the event terms. Non-refundable. Resale invalidates the ticket.</div>}
      </div>
    </div>
  );
};

/* EmailPreviewCard — visual preview of an email design with toggleable blocks */
